import { Link } from 'react-router-dom'
import { Input, ModalBody } from 'reactstrap'
import CustomModal from './../CustomModal'
import './../style.css'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'
export default function AddLTIContent(props) {
  const dispatch = useDispatch()
  let language = props.language || {}

  return (
    <CustomModal
      courseId={props.course_id}
      title={language.courses ? language.courses.add_lti : null}
      size='lg'
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          props.addLTI()
          dispatch(invalidateCoursesOverview())
        }}
      >
        <ModalBody>
          <div className='row'>
            <div className='col-12'>
              <div>
                <Input
                  type='text'
                  name='title'
                  placeholder={language.settings?.title}
                  value={props.title || ''}
                  onChange={(event) =>
                    props.onChangeTitleText(event.target.value)
                  }
                  required
                />
              </div>
              <div className='mt-2'>
                <Input
                  type='text'
                  name='launchUrl'
                  placeholder='URL'
                  value={props.launchUrl || ''}
                  onChange={props.onChangeLTI}
                  required
                />
              </div>
              <div className='mt-2'>
                <Input
                  type='text'
                  name='consumerKey'
                  placeholder={language.courses?.consumer_key}
                  value={props.consumerKey || ''}
                  onChange={props.onChangeLTI}
                  required
                />
              </div>
              <div className='mt-2'>
                <Input
                  type='text'
                  placeholder={language.courses?.shared_secret}
                  name='sharedSecret'
                  value={props.sharedSecret || ''}
                  onChange={props.onChangeLTI}
                  required
                />
              </div>
              <div className='mt-2'>
                <Input
                  name='customParameters'
                  rows='4'
                  placeholder={language.courses?.custom_parameters}
                  value={props.customParameters || ''}
                  onChange={props.onChangeLTI}
                  style={{ resize: 'none' }}
                  type='textarea'
                ></Input>
              </div>
              <div className='custom-control custom-checkbox-info mt-2'>
                <input
                  className='custom-control-input'
                  id='required_content'
                  type='checkbox'
                  checked={props.requiredContent}
                  onChange={props.setRequired}
                />
                <label
                  className='custom-control-label '
                  htmlFor='required_content'
                  style={{ fontSize: '14px', paddingTop: '2px' }}
                >
                  {language?.courses?.required}
                </label>
              </div>
            </div>
          </div>
          <div
            className='text-container-btn-container mt-5 p-0 ml-0'
            style={{ marginTop: '30px' }}
          >
            <SubmitModalButton
              text={language.general ? language.general.submit : null}
            />
            <Link to={`/course/${props.course_id}/edit`}>
              <CancelModalButton
                text={language.general ? language.general.cancel : null}
              />
            </Link>
          </div>
        </ModalBody>
      </form>
    </CustomModal>
  )
}
